import React from "react";
import { Link } from "react-router-dom";
import { t, useLanguage } from "@/lib/i18n";
export default function NotFound() {
  useLanguage();
  return <main className="min-h-screen parchment-grain p-10 text-center"><h1 className="font-serif text-4xl">404</h1><p className="my-5">{t("Page not found")}</p><Link to="/" className="underline">{t("Back to home")}</Link></main>;
}
